import dynamic from "next/dynamic";
import type { VideoJsPlayerOptions } from "video.js";

type RecordingPlayerProps = VideoJsPlayerOptions & { recordingId: string };

export const RecordingPlayer = dynamic<RecordingPlayerProps>(
  () => import("./recording-player").then((mod) => mod.RecordingPlayer),
  {
    ssr: false,
  }
);
